import { useState } from "react";

import { observer } from "mobx-react";
import axios from "axios";
import { Box, Link, Typography } from "@mui/material";

import schema from "./schema";
import { DOMAIN } from "config/config";

import VersionList from "Components/VersionList";

import Formizo from "Components/LabIZO/Formizo";
import { Accessor, store, ColorX, Env } from "static";
import { VStack, HStack, Spacer } from "Components/LabIZO/Stackizo";
import { StyledButton, StyledLinearProgress } from "Components/LabIZO/Stylizo";
import { useNavigate } from "react-router-dom";
import { render } from "react-dom";
import { set } from "lodash";

//SAML
import { useEffect } from "react";

const EnableADFS = process.env.REACT_APP_ENABLE_ADFS;
let FailedLogin = false;

interface IHomeProps {
  history?: any;

  username?: "";
  userDisplayName?: "";
  page?: "user";
  loading?: false;
  errorMsg?: "";
}

interface IFormProps {
  username: string;
}

const Home = (props: IHomeProps) => {
  const [username, setUsername] = useState("");
  const [userDisplayName, setUserDisplayName] = useState("");
  const [page, setPage] = useState("user");
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  let MountForm: any;

  //SAML
  useEffect(() => {
    if (EnableADFS === "true") {
      _redirectToSSO();
    }
  }, []);

  const _redirectToSSO = async () => {
    console.log("_signIn");
    let url = DOMAIN + "/login";

    setLoading(true);

    try {
      // get params from URL
      const queryParams = new URLSearchParams(window.location.search);
      //param begins with ?data=
      const dataParam = queryParams.get("data");

      if (dataParam) {
        let payloadData = JSON.parse(atob(dataParam)); // data is encoded base64 JSON string
        let { Success } = payloadData;

        if (Success === true) {
          if (FailedLogin === true) {
            FailedLogin = false;
          }
          store.setUser(payloadData);

          store.Alert("Login Successful", "success");
          await Env.CheckInitialized();
          if (!store.isInitialized()) {
            navigate("/Initialize");
          } else {
            await Env.GetSysInfo();
            redirectToDashboard();
            store.isLoading(false);
            setLoading(false);
          }
        } else {
          store.Alert("Incorrect Password", "error");
          setLoading(false);
          FailedLogin = true;
        }
      } else {
        //If no params, redirect to SSO
        window.location.href = url;
      }
    } catch (e) {
      store.Alert("Cannot connect to server", "error");
      setLoading(false);
    }
  };

  const onMountForm = (callbacks?: any) => {
    MountForm = callbacks;
  };

  const _CheckUser = async (formProps: IFormProps) => {
    let url = DOMAIN + "/Base/Authorize/CheckUserName";
    let req = {
      ...formProps,
    };

    setLoading(true);

    try {
      let res = await axios.post(url, req);
      console.log(res);
      let { Success, payload } = res.data;
      if (Success) {
        if (payload.hasUser) {
          setPage("password");
          setLoading(false);
          setUsername(formProps.username);
          setUserDisplayName(payload.UserDisplayName);
        } else {
          store.Alert("User not found", "error");
          setLoading(false);
        }
      }
    } catch (e) {
      store.Alert("Cannot connect to server", "error");
      setLoading(false);
    }
  };

  const _Login = async (formProps: IFormProps) => {
    console.log("_signIn");
    let url = DOMAIN + "/Base/Authorize/SignIn";

    let req = { username };
    req = { ...req, ...formProps };
    setLoading(true);

    try {
      let res = await axios.post(url, req);

      let { Success, payload } = res.data;
      if (Success === true) {
        console.log(payload);
        store.setUser(payload);

        store.Alert("Login Successful", "success");
        await Env.CheckInitialized();
        if (!store.isInitialized()) {
          navigate("/Initialize");
        } else {
          await Env.GetSysInfo();
          redirectToDashboard();
        }
      } else {
        store.Alert("Incorrect Password", "error");
        setLoading(false);
      }
    } catch (e) {
      store.Alert("Cannot connect to server", "error");
      setLoading(false);
    }
  };

  const _ForgotPassword = async (formProps: { username: string; email: string }) => {
    let url = DOMAIN + "/Base/Authorize/ForgotPassword";

    setLoading(true);

    try {
      let res = await axios.post(url, formProps);

      let { Success, payload } = res.data;
      console.log(payload);
      if (Success === true) {
        store.setUser(payload);
        store.Alert("Please Check your email", "success");
        setPage("user");
        setLoading(false);
      } else {
        store.Alert(payload.message, "error");
        setLoading(false);
      }
    } catch (e) {
      store.Alert("Cannot connect to server", "error");
    }
  };

  const redirectToDashboard = () => {
    if (store.isInitialized()) {
      setTimeout(() => {
        navigate("/Dashboard");
        store.isLoading(false);
      }, 1000);
    }
  };

  const renderNextButton = () => {
    return (
      <VStack width="100%" key="next">
        <StyledButton
          id="next"
          onClick={() => {
            MountForm.Submit();
          }}
          theme={{
            label: "white",
            background: loading ? ColorX.GetColorCSS("Primary2") : ColorX.GetColorCSS("Primary"),
            hover: {
              background: ColorX.GetColorCSS("Primary2"),
            },
            borderRadius: "0px",
            width: "100%",
          }}
          disabled={loading}
        >
          <HStack>
            <div>NEXT</div>
            <Spacer />
            <i className="fas fa-arrow-right" />
          </HStack>
        </StyledButton>
        {loading && <StyledLinearProgress theme={{ bar: ColorX.GetColorCSS("Primary"), background: ColorX.GetColorCSS("Primary2") }} />}
      </VStack>
    );
  };

  const renderLoginButton = () => {
    return (
      <VStack width="100%" key="next">
        <StyledButton
          id="login-button"
          onClick={() => {
            MountForm.Submit();
          }}
          theme={{
            label: "white",
            background: loading ? ColorX.GetColorCSS("Primary2") : ColorX.GetColorCSS("Primary"),
            hover: {
              background: ColorX.GetColorCSS("Primary2"),
            },
            borderRadius: "0px",
            width: "100%",
          }}
          disabled={loading}
        >
          <HStack>
            <div>Log in</div>
            <Spacer />
            <i className="fas fa-arrow-right" />
          </HStack>
        </StyledButton>
        {loading && <StyledLinearProgress theme={{ bar: ColorX.GetColorCSS("Primary"), background: ColorX.GetColorCSS("Primary2") }} />}
      </VStack>
    );
  };
  const renderForgotPasswordButton = () => {
    return (
      <VStack width="100%" key="next">
        <StyledButton
          id="next"
          onClick={() => {
            MountForm.Submit();
          }}
          theme={{
            label: "white",
            background: loading ? ColorX.GetColorCSS("Primary2") : ColorX.GetColorCSS("Primary"),
            hover: {
              background: ColorX.GetColorCSS("Primary2"),
            },
            borderRadius: "0px",
            width: "100%",
          }}
        >
          <HStack>
            <div>Forgot Password</div>
            <Spacer />
            <i className="fas fa-arrow-right" />
          </HStack>
        </StyledButton>
      </VStack>
    );
  };

  const renderForm = () => {
    return (
      <Formizo
        formID="login-form"
        height={page === "user" ? "95px" : page === "password" ? "95px" : page === "forgot" ? "160px" : "225px"}
        schema={page === "user" ? schema.loginName : page === "password" ? schema.loginPassword : page === "forgot" ? schema.forgotPassword : schema.initial}
        buttons={[page === "user" ? renderNextButton() : page === "password" ? renderLoginButton() : page === "forgot" ? renderForgotPasswordButton() : renderLoginButton()]}
        buttonPadding={0}
        onSubmit={page === "user" ? _CheckUser : page === "password" ? _Login : page === "forgot" ? _ForgotPassword : () => {}}
        onMounted={onMountForm}
        fieldStyle="standard"
        fieldSize="small"
        errorsShowOnHelperText={false}
        theme={{
          textfield: {
            input: ColorX.GetColorCSS("Primary"),
            background: "transparent",
            line: "transparent",
          },
        }}
        disabled={{ loading }}
      />
    );
  };

  const backToUser = () => {
    setPage("user");
    setUsername("");
    setUserDisplayName("");
  };
  const forgotPasswordPage = () => {
    setPage("forgot");
    setUsername("");
    setUserDisplayName("");
  };

  const renderHeaderMessage = () => {
    switch (page) {
      default:
      case "user":
        return "Log in with your User ID";
      case "password":
        return <Link onClick={() => backToUser()}>{"Not " + userDisplayName + " ?"}</Link>;
      case "forgot":
        return <Link onClick={() => backToUser()}>{"Back to Login Page"}</Link>;
    }
  };

  const renderForgotButton = () => {
    return (
      <VStack style={{ height: "auto" }}>
        <StyledButton onClick={forgotPasswordPage}>
          <HStack>
            <div>Forgot Password</div>
            <Spacer />
          </HStack>
        </StyledButton>
      </VStack>
    );
  };

  const renderInside = () => {
    console.log("FailedLogin", FailedLogin);
    console.log("EnableADFS", EnableADFS);
    if (EnableADFS === "true" && FailedLogin == false) {
      return <></>;
    } else if (EnableADFS === "true" && FailedLogin == true) {
      return (
        <VStack>
          <Spacer />
          <Box margin={1} width={1}>
            Invaild Username or Password
          </Box>
          <Box width="300px" style={{ background: "white" }}></Box>
          <Spacer />
        </VStack>
      );
    } else {
      return (
        <VStack>
          <Spacer />
          <Box margin={1} width={1}>
            {renderHeaderMessage()}
          </Box>
          <Box width="300px" style={{ background: "white" }}>
            {renderForm()}
          </Box>
          {page != "forgot" && renderForgotButton()}
          <Spacer />
        </VStack>
      );
    }
  };

  const renderLogo = () => {
    let style = {
      color: ColorX.GetColorCSS("Primary2", 0.5),
      fontSize: 9,
    };
    return (
      <VStack gap="1px" alignItems="center">
        <Box width="300px" height="350px" className="syva_logo gradient" sx={{ backgroundColor: ColorX.GetColorCSS("Primary") }}></Box>
        <Typography variant="h2" style={{ color: ColorX.GetColorCSS("Primary") }}>
          SYVA
        </Typography>
        {VersionList(style)}
        <HStack gap={1}>{renderPackages(style)}</HStack>
      </VStack>
    );
  };

  const renderPackages = (style: any) => {
    let rtn = [];
    if (Accessor.EnvWith("AVATAR")) {
      rtn.push(
        <Typography key="avatar" style={style}>
          [AVATAR]
        </Typography>
      );
    }
    if (Accessor.EnvWith("AWS")) {
      rtn.push(
        <Typography key="aws" style={style}>
          [AWS]
        </Typography>
      );
    }
    return rtn;
  };

  return (
    <VStack
      style={{
        background: ColorX.GetColorCSS("Background"),
        color: ColorX.GetColorCSS("Primary"),
      }}
    >
      <Spacer />
      <HStack gap="75px">
        <Spacer />
        {renderLogo()}
        {renderInside()}
        <Spacer />
      </HStack>
      <Spacer />
    </VStack>
  );
};

export default observer(Home);
